import firebaseModules from "./Firebase";

const db = firebaseModules.db;

export const pushDataToCollection = async (collectionName, data, uid) => {
  await db.collection(collectionName).doc(uid.toString()).set(data);
};

export const fetchCollectionById = async (collectionName, uid) => {
  const doc = db.collection(collectionName).doc(uid);
  const data = await doc.get();
  return data.data();
};
